class EmptyTargetGroupAnalysis {}

export default EmptyTargetGroupAnalysis
